'use es6';

import { createSelector } from 'reselect';
import { getFormFieldGroups } from './FormDefinition';
import { getPropertiesById } from './Properties';
import { getPropertyId, isSupportedProperty } from 'FormsUI/utils/PropertiesUtils';
export const getMainFormFieldGroups = createSelector([(state, variant) => getFormFieldGroups(state, variant), getPropertiesById], (formFieldGroups, propertiesById) => {
  return formFieldGroups.map(formFieldGroup => Object.assign({}, formFieldGroup, {
    fields: formFieldGroup.fields.filter(formField => !propertiesById[getPropertyId(formField)] || isSupportedProperty(propertiesById[getPropertyId(formField)]))
  })).filter(formFieldGroup => formFieldGroup.default);
});